import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';
import { Store } from '@ngxs/store';
import { List } from '@shared/models/interfaces/List.interface';
import { Procedure } from '@shared/models/interfaces/procedures.interface';
import { HttpService } from '@shared/providers/http.service';

@Injectable({
  providedIn: 'root'
})
export class ProceduresService extends HttpService {
  constructor(httpClient: HttpClient, store: Store) {
    super(environment.endpoints.procedures, httpClient, store);
  }
  list(token, page, searchName = '', perPage = environment.perPage, isActive = true) {
    const params = new HttpParams()
      .set('perPage', String(perPage))
      .set('page', String(page))
      .set('searchName', String(searchName))
      .set('isActive', String(isActive));

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }),
      params
    };
    return this.getAsync<List<Procedure>>('', httpOptions);
  }

  create(procedureName: string) {
    return this.postAsync({ procedureName });
  }
  update(procedure: Procedure) {
    return this.putAsync({ ...procedure }, `/${procedure.procedureId}`);
  }
  deleteProcedure(procedure: Procedure) {
    return this.deleteAsync(`/${procedure.procedureId}`);
  }
}
